import React from 'react'
import { Table } from "reactstrap";
import Layout from "../Layout/Layout";
import Modal from "../../../Components/Modals/modal";
import AddPeople from "./Add-People-Modal/index";
import deleteIcon from "../../../../images/new-images/delete.svg";
import GoalSettingWorksheetsLogo from "../../../../images/new-images/goalseetingworksheet.png";
import './Manage-Worksheet.css'

const ManageWorksheet = (props) => {
    return (
        <Layout
        headerIcon={GoalSettingWorksheetsLogo}
        headerText='Manage Worksheet'
        button='ADD PEOPLE TO WORKSHEET'
    click={props.handleAddModal}
    >
            <div className='manage-worksheet'>
            <Modal
          assessmentModal={props.AddModal}
          handleModalClose={props.handleModalClose}
          modalHeading="ADD PEOPLE"
        >
          <AddPeople/>
        </Modal>
            <Table>
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Short Name</th>
                        <th>Delete User</th>
                    </tr>
                </thead>
                <tbody>
                    {props.sharedTo.shared_with_list && props.sharedTo.shared_with_list.map((sharedList, index) => {
                        return (
                            <tr key={index}>
                                <td>{sharedList.shared_to__email}</td>
                                <td>{sharedList.shared_to__short_name}</td>
                                <td><img className='delete-icon' src={deleteIcon} /></td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            </div>
            </Layout>
    )
}

export default ManageWorksheet



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Manage-WorkSheet/Manage-Worksheet.jsx